import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { productDetails, updateProduct } from "../../redux/CrudSlice";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Box,
  Paper,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { imagePath } from "../../helper/Helper";

function EditProduct() {
  const [img, setImg] = useState(null);
  const [imgPreview, setImgPreview] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const { isLoading, isError, isUpdate } = useSelector(
    (state) => state.crudKey
  );
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(productDetails(id)).then((action) => {
      if (action.payload) {
        console.log(action.payload.data);
        const productData = action.payload.data;
        setValue("title", productData.title);
        setValue("description", productData.description);
        setImg(productData.image);
      }
    });
  }, [dispatch, id, setValue]);
  useEffect(() => {
    isUpdate &&
      !isLoading &&
      toast.success("Product updated successful", { autoClose: 2000 });
    setTimeout(() => {
      isUpdate && !isLoading && navigate("/product-list");
    }, 2000);
  }, [isUpdate]);

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", data.description);
    if (data.file[0]) {
      formData.append("image", data.file[0]);
    }
    formData.append("id", id);
    dispatch(updateProduct(formData));
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImgPreview(previewUrl);
    }
  };
  console.log(img);

  return (
    <>
      <Container maxWidth="xs" component={Paper} style={{paddingTop:"5px", paddingBottom:"25px", marginTop:"15px"}}>
      <Typography variant='h3' style={{  marginBottom: 25,  fontWeight: "bold", textAlign:"center"  }} sx={{ fontSize: { xs: '26px' , sm: '30px', md: '40px'} }}>Edit Product</Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 10, alignItems: "center" }}
          >
            <Grid item xs={12}>
            <Typography className="label">Product Title</Typography>
              <TextField
                fullWidth
                // label="Title"
                variant="outlined"
                error={!!errors.title}
                helperText={errors.title ? "Title is required" : ""}
                {...register("title", { required: true })}
                style={{ marginBottom: 10 }}
              />
            </Grid>
            <Grid item xs={12}>
            <Typography className="label">Product Description</Typography>
              <TextField
                fullWidth
                variant="outlined"
                error={!!errors.description}
                helperText={errors.description ? "Description is required" : ""}
                {...register("description", { required: true })}
                style={{ marginBottom: 10 }}
              />
            </Grid>
            <Grid item xs={12}>
            <Typography className="label">Product Image</Typography>
              <TextField
                fullWidth
                type="file"
                variant="outlined"
                error={!!errors.file}
                helperText={errors.file ? "File is required" : ""}
                {...register("file")}
                onChange={handleImageChange}
                style={{ marginBottom: 10 }}
                inputProps={{ accept: "image/jpeg, image/jpg" }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box
                component="img"
                sx={{
                  width: "150px",
                  height: "110px",
                  objectFit: "cover",
                  borderRadius: 2,
                }}
                alt="Example Image"
                src={imgPreview || (img ? imagePath(img) : null)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                type="submit"
                sx={{ py: 1.5, mt: 1, fontSize: "16px", fontWeight: "bold" }}
              >
                {isLoading ? "Please Wait....." : "Update Product"}
              </Button>
              {isError && <p>{isError}</p>}
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
}

export default EditProduct;
